import { cx } from '@/lib/cx';
import styles from './Seal2040.module.css';

export interface Seal2040Props {
  className?: string;
}

/**
 * Roseta de geometria sagrada que ornamenta el primer cero del sello.
 *
 * OJO AL TAMANO, que estuvo mal contado hasta el 26-jul-2026: esta roseta NO
 * cabe en el contador del cero ni lo pretende. Medido sobre el build servido, el
 * hueco del cero son **0,225 em** y la roseta **0,62 em** — casi el triple: va
 * MONTADA SOBRE el glifo, no inscrita dentro de el. De ahi sale E-1 (los doce
 * petalos cruzan el anillo del cero y le ponen otro oro debajo). El remedio vive
 * en `.rosette` del CSS, con la tabla de medidas; aqui solo queda dicho para que
 * nadie vuelva a leer "inscrita en el contador" y se lo crea.
 */
function Rosette() {
  const petals = Array.from({ length: 12 }, (_, i) => i * 30);
  return (
    <svg
      className={styles.rosette}
      viewBox="0 0 100 100"
      fill="none"
      stroke="currentColor"
      strokeWidth={0.7}
      vectorEffect="non-scaling-stroke"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="50" cy="50" r="46" />
      <circle cx="50" cy="50" r="34" opacity="0.7" />
      <circle cx="50" cy="50" r="9" />
      {petals.map((angle) => (
        <ellipse key={angle} cx="50" cy="28" rx="9" ry="20" transform={`rotate(${angle} 50 50)`} />
      ))}
    </svg>
  );
}

/**
 * SELLO "2040" — el ornamento firma del hero de Ciudad de México.
 *
 * Las cuatro cifras son TEXTO HTML REAL y seleccionable; la roseta es un SVG
 * decorativo SUPERPUESTO al primer cero (no inscrito en su contador — ver el
 * aviso de `Rosette`, que esa imprecisión es la que escondio E-1). En el mockup
 * la roseta SUSTITUYE al cero: aqui se le monta encima para no dejar un glifo
 * apagado que hundiria el contraste de un texto real. Registrado en
 * VISUAL_DEVIATIONS §1.5, y su contraste cerrado en §1.5.bis.
 *
 * El año sale del gancho comercial del propio evento ("El reloj corre hacia el
 * 2040", `salesHook` de `/mexico`): no es una cifra inventada aquí.
 */
export function Seal2040({ className }: Seal2040Props) {
  return (
    <div className={cx(styles.seal, className)}>
      <p className={styles.year}>
        2
        <span className={styles.zeroSlot}>
          0
          <Rosette />
        </span>
        40
      </p>
      <p className={styles.caption}>
        <span>El año de la maduración</span>
        <span>y el servicio consciente</span>
      </p>
    </div>
  );
}
